import { render, staticRenderFns } from "./OracleOrders.vue?vue&type=template&id=92036e8c&"
import script from "./OracleOrders.vue?vue&type=script&lang=js&"
export * from "./OracleOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports